import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { registerUser } from '../../../react-cognito';
import { NotificationManager } from 'react-notifications';
import { Loader } from '../../../components/loader';
import { createFormula } from '../../../actions/addTreatments';
import { forceInputUppercase } from "../../../utils/helper";

const $ = window.$;
const initialState = {
    currentFormNotValid:false,
    newFormulaView:false,
    newDosageView:false,
    calculationType: '',
    treatmentName:'',
    strengthMg: '',
    strengthMl: '',
    doseMg: '',
    doseLb: '',
    doseType:'Lb',
    doseTimes: '',
    dosageMl: '',
    dosageLb: '',
    minDuration: '',
    maxDuration: '',
    loading:false
}
let formdata = {};
class NewOralSuspension extends React.Component {
    constructor(props) {
        super(props);
    }

    state = initialState;

    changeVal = (event) => {
        let excludes = [
            "strengthMg",
            "strengthMl",
            "doseMg",
            "doseLb",
            "minDuration",
            "maxDuration",
            "doseType",
            "doseTimes",
            "dosageMl",
            "dosageLb"
          ];
        if (!excludes.includes(event.target.name)) forceInputUppercase(event);
        const value = event.target.value;
        this.setState({
            ...this.state,
            [event.target.name]: value
        });
    }

    resetState = () => {
        this.setState(initialState);
    }

    closeModal = () => {
        $('#new_oral_suspension').modal('hide');
        this.resetState();
    }

    submitFormula = (event) => {
        event.preventDefault();
        this.setState({loading: true});
        if(this.validateFormulaForm()){
            let data = Object.values(formdata).map(key=>{
                if(key!==null) {
                    return true;
                }
                else{
                    return false;
                }
            });

            if(!data.includes(false)){
                this.props.createFormula(formdata);
            }
            else{
                this.setState({currentFormNotValid: true});
                this.setState({loading: false});
                NotificationManager.warning("Please check input details again.");  
            }
        }
        
    }
    submitDosage = (event) => {
        event.preventDefault();
        this.setState({loading: true});
        if(this.validateDosageForm()){
            let data = Object.values(formdata).map(key=>{
                if(key!==null) {
                    return true;
                }
                else{
                    return false;
                }
            });

            if(!data.includes(false)){
                this.props.createFormula(formdata);
            }
            else{
                this.setState({currentFormNotValid: true});
                this.setState({loading: false});
                NotificationManager.warning("Please check input details again.");  
            }
        }
        
    }
    validateFormulaForm() {
        const data = {
            PetShopId: this.props.petShop.currentPetshop.id,
            treatmentName: this.state.treatmentName.trim().length > 0 ? this.state.treatmentName : null,
            calculationType: this.state.calculationType,
            strengthMg: this.state.strengthMg.toString().trim().length > 0 ? this.state.strengthMg : null,
            strengthMl: this.state.strengthMl.toString().trim().length > 0 ? this.state.strengthMl : null,
            doseMg: this.state.doseMg.toString().trim().length > 0 ? this.state.doseMg : null,
            doseLb: this.state.doseLb.toString().trim().length > 0 ? this.state.doseLb : null,
            doseTimes: this.state.doseTimes.toString().trim().length > 0 ? this.state.doseTimes : null,
            minDuration: this.state.minDuration.toString().trim().length > 0 ? this.state.minDuration : null,
            maxDuration: this.state.maxDuration.toString().trim().length > 0 ? this.state.maxDuration : null,
            doseType:this.state.doseType
        };
        formdata = Object.assign({}, data);
        return true;
    }
    validateDosageForm(){
        const data= {
            PetShopId: this.props.petShop.currentPetshop.id,
            treatmentName: this.state.treatmentName.trim().length > 0 ? this.state.treatmentName: null,
            calculationType: this.state.calculationType,
            dosageMl: this.state.dosageMl.toString().trim().length > 0 ? this.state.dosageMl:null,
            dosageLb: this.state.dosageLb.toString().trim().length > 0 ? this.state.dosageLb:null,
            minDuration: this.state.minDuration.toString().trim().length > 0 ? this.state.minDuration:null,
            maxDuration: this.state.maxDuration.toString().trim().length > 0 ? this.state.maxDuration:null,
            doseTimes:this.state.doseTimes.toString().trim().length > 0 ? this.state.doseTimes:null,
            doseType:this.state.doseType
        };
        formdata = Object.assign({},data);
        return true;
    }
    componentWillReceiveProps = (nextProps) => {
    
        if(this.props.setCalculations !== nextProps.setCalculations) {
            this.resetState();
            this.setState({loading: false});
            this.closeModal();
        }
        if(this.props.setCalculationsError !== nextProps.setCalculationsError) {
            this.resetState();
            this.setState({loading: false});
            this.closeModal();
            NotificationManager.error("Failed to add calculator");
        }
    
    }

    render() {
        const {treatmentName, strengthMg, strengthMl, doseMg, doseLb,dosageLb,dosageMl, doseTimes, minDuration, maxDuration, doseType,newFormulaView, newDosageView} = this.state;

        return (
            <div className="modal fade show" id="new_oral_suspension" tabIndex="-1" role="dialog" style={{overflowY: 'auto'}}>
                {newFormulaView ? 
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <form onSubmit={this.submitFormula} className="m-form">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">New Oral Suspension Dosage Calculator
                                <br />
                                    <small>Use Formula - Please enter all values below</small>
                                </h5>
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>

                            </div>                         
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="form-group m-form__group row">
                                            <label className="col-lg-4 col-form-label">Medication Name (eg: Amoxicillin liquid for puppies):</label>
                                            <div className="col-lg-8">
                                                <input type="text" name="treatmentName" value={treatmentName} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                <span className={formdata.treatmentName===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}> Enter medication name</span>
                                            </div>
                                        </div>
                                        <div className="m-form__seperator m-form__seperator--dashed my-3"></div>
                                        <div className="form-group m-form__group row">
                                            <label className="col-lg-4 col-form-label">Strength Of Medication (eg. 200mg per 5ml):</label>
                                            <div className="col-6 col-lg-4 input_span">
                                                <div className='input-group'>
                                                    <input type="number" name="strengthMg" value={strengthMg} onChange={this.changeVal} className="form-control m-input" placeholder="" />
                                                    <div className="input-group-append">
                                                        <span className="input-group-text">mg </span>
                                                    </div>
                                                    
                                                </div>
                                                <span className={formdata.strengthMg === null && this.state.currentFormNotValid ? 'm-form__help_danger' : 'm-form__help'}>Please enter strength (mg)</span>
                                            </div>
                                            <div className="col-6 col-lg-4 input_span">
                                                <div className='input-group'>
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">per </span>
                                                    </div>
                                                    <input type="number" name="strengthMl" value={strengthMl} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                    <div className="input-group-append">
                                                        <span className="input-group-text"> ml </span>
                                                    </div>
                                                </div>
                                                <span className={formdata.strengthMl===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please enter strength (ml)</span>
                                            </div>
                                          
                                        </div>
                                        <div className="form-group m-form__group row">
                                            <div className="col-lg-8">
                                                <div className="m-radio-inline">
                                                    <label className="m-radio m-radio--solid m-radio--state-success">
                                                        <input type="radio" name="doseType" checked={doseType === "Lb"} onChange={this.changeVal} value="Lb" /> Lb
                                                        <span></span>
                                                    </label>
                                                    <label className="m-radio m-radio--solid m-radio--state-success">
                                                        <input type="radio" name="doseType" checked={doseType === "Kg"} onChange={this.changeVal} value="Kg" /> Kg
                                                        <span></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group m-form__group row">
                                            <label className="col-lg-4 col-form-label">Vet recommended dose for animal (eg. 5mg per 1{(doseType === "Lb") ? "lb" : "kg"}):</label>
                                            <div className="col-6 col-lg-4 input_span">
                                                <div className='input-group'>
                                                    <input type="number" name="doseMg" value={doseMg} onChange={this.changeVal} className="form-control m-input" placeholder="" />
                                                    <div className="input-group-append">
                                                        <span className="input-group-text"> mg </span>
                                                    </div>
                                                </div>                                                
                                                <span className={formdata.doseMg === null && this.state.currentFormNotValid ? 'm-form__help_danger' : 'm-form__help'}>Please enter dose (mg)</span>
                                            </div>
                                            <div className="col-6 col-lg-4 input_span" >
                                                <div className='input-group'>
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">  per </span>
                                                    </div>
                                                    <input type="number" name="doseLb" value={doseLb} onChange={this.changeVal} className="form-control m-input" placeholder="" />
                                                    <div className="input-group-append">
                                                        <span className="input-group-text">  {(doseType === "Lb") ? "lb" : "kg"} </span>
                                                    </div>
                                                </div>
                                                <span className={formdata.doseLb === null && this.state.currentFormNotValid ? 'm-form__help_danger' : 'm-form__help'}>Please enter dose ({(doseType === "Lb") ? "lb" : "kg"})</span>
                                            </div>
                                        </div>
                                        <div className="form-group m-form__group row">
                                            <label className="col-lg-4 col-form-label">How many times a day? (eg: 2x a day):</label>
                                            <div className="col-lg-4 pr-0">
                                                <div className='input-group'>
                                                <input type="number" name="doseTimes" value={doseTimes} onChange={this.changeVal} className="form-control m-input" placeholder="" />
                                                <div className="input-group-append">
                                                        <span className="input-group-text"> times per day </span>
                                                    </div>
                                                </div>
                                                <span className={formdata.doseTimes === null && this.state.currentFormNotValid ? 'm-form__help_danger' : 'm-form__help'}>Please enter dose (x a day)</span>
                                            </div>                                        
                                        </div>
                                        <div className="form-group m-form__group row">
                                            <label className="col-lg-4 col-form-label">Recommended Duration(eg: 7 days  min. 14 days max.):</label>
                                            <div className="col-6 col-lg-4 input_span">
                                                <div className='input-group'>
                                                <input type="number" name="minDuration" value={minDuration} onChange={this.changeVal} className="form-control m-input" placeholder="" />
                                                <div className="input-group-append">
                                                        <span className="input-group-text"> days min. </span>
                                                </div>
                                                </div>
                                                <span className={formdata.minDuration === null && this.state.currentFormNotValid ? 'm-form__help_danger' : 'm-form__help'}>Please enter minimum duration (days)</span>
                                            </div>
                                            <div className="col-6 col-lg-4 input_span">
                                                <div className='input-group'>
                                                <input type="number" name="maxDuration" value={maxDuration} onChange={this.changeVal} className="form-control m-input" placeholder="" />
                                                <div className="input-group-append">
                                                        <span className="input-group-text"> days max. </span>
                                                </div>
                                                </div>
                                                <span className={formdata.maxDuration === null && this.state.currentFormNotValid ? 'm-form__help_danger' : 'm-form__help'}>Please enter maximum duration (days)</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                {this.state.loading == false ?
                                    <div>
                                        <button type="button" className="btn btn-secondary m-btn--pill mx-2" onClick={this.closeModal}>Close</button>
                                        <button type="submit" className="btn btn-primary m-btn--pill">Submit</button>
                                    </div>
                                :
                                    <div className="center-row">
                                        <Loader size={50} />
                                    </div>
                                }
                            </div>
                        </form>
                    </div>
                </div>
                :newDosageView ?
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <form onSubmit={this.submitDosage} className="m-form">
                            <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">New Oral Suspension Dosage Calculator
                                <br />
                                    <small>Use Pre-set Dosage - Please enter all values below</small>
                                </h5>
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="form-group m-form__group row">
                                            <label className="col-lg-4 col-form-label">Medication Name (eg: Albon liquid for puppies):</label>
                                            <div className="col-lg-8">
                                                <input type="text" name="treatmentName" value={treatmentName} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                <span className={formdata.treatmentName===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please enter medication name</span>
                                            </div>
                                        </div>
                                        <div className="m-form__seperator m-form__seperator--dashed my-3"></div>
                                        <div className="form-group m-form__group row">
                                            <div className="col-lg-8">
                                                <div className="m-radio-inline">
                                                    <label className="m-radio m-radio--solid m-radio--state-success">
                                                        <input type="radio" name="doseType" checked={doseType === "Lb"} onChange={this.changeVal} value="Lb" /> Lb
                                                        <span></span>
                                                    </label>
                                                    <label className="m-radio m-radio--solid m-radio--state-success">
                                                        <input type="radio" name="doseType" checked={doseType === "Kg"} onChange={this.changeVal} value="Kg" /> Kg
                                                        <span></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group m-form__group row">
                                            <label className="col-lg-4 col-form-label">Vet recommended dose for animal (eg: 0.25 ml per 1{(doseType === "Lb") ? "lb" : "kg"}):</label>
                                            <div className="col-6 col-lg-4 input_span">
                                                <div className='input-group'>
                                                <input type="number" name="dosageMl" value={dosageMl} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                    <div className="input-group-append">
                                                        <span className="input-group-text">ml </span>
                                                    </div>
                                                </div>
                                                
                                                <span className={formdata.dosageMl===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please enter dosage in (ml)</span>
                                            </div>
                
                                            <div className="col-6 col-lg-4 input_span">
                                                <div className='input-group'>
                                                <div className="input-group-prepend">
                                                        <span className="input-group-text">per </span>
                                                    </div>
                                                <input type="number" name="dosageLb" value={dosageLb} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                <div className="input-group-append">
                                                        <span className="input-group-text">{(doseType === "Lb") ? "lb" : "kg"} </span>
                                                    </div>
                                                </div>
                                                
                                                <span className={formdata.dosageLb===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please enter dosage in ({(doseType === "Lb") ? "lb" : "kg"})</span>
                                            </div>
                                        </div>
                                        <div className="form-group m-form__group row">
                                            <label className="col-lg-4 col-form-label">How many times a day? (eg: 2x a day):</label>
                                            <div className="col-12 col-lg-8 input_span">
                                                <div className='input-group'>
                                                    <input type="number" name="doseTimes" value={doseTimes} onChange={this.changeVal} className="form-control m-input" placeholder="" />
                                                    <div className="input-group-append">
                                                        <span className="input-group-text">times per day </span>
                                                    </div>
                                                </div>                                               
                                                <span className={formdata.doseTimes === null && this.state.currentFormNotValid ? 'm-form__help_danger' : 'm-form__help'}>Please enter dose (x a day)</span>
                                            </div>
                                        </div>
                                        <div className="form-group m-form__group row">
                                            <label className="col-lg-4 col-form-label">Recommended Duration(eg: 7 days  min. 14 days max.):</label>
                                            <div className="col-6 col-lg-4 input_span">
                                                <div className='input-group'>
                                                <input type="number" name="minDuration" value={minDuration} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                <div className="input-group-append">
                                                        <span className="input-group-text">days min. </span>
                                                </div>
                                                </div>
                                                <span className={formdata.minDuration===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please enter minimum duration (days)</span>
                                            </div>
                                            <div className="col-6 col-lg-4 input_span">
                                                <div className='input-group'>
                                                <input type="number" name="maxDuration" value={maxDuration} onChange={this.changeVal} className="form-control m-input" placeholder=""/>
                                                <div className="input-group-append">
                                                        <span className="input-group-text">days max.</span>
                                                </div>
                                                </div>
                                                
                                                <span className={formdata.maxDuration===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please enter maximum duration (days)</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                {this.state.loading == false ?
                                    <div>
                                        <button type="button" className="btn btn-secondary m-btn--pill mx-2" onClick={()=>this.closeModal()}>Close</button>
                                        <button type="submit" className="btn btn-primary m-btn--pill">Submit</button>
                                    </div>
                                :
                                    <div className="center-row">
                                        <Loader size={50} />
                                    </div>
                                }
                            </div>
                        </form>
                    </div>
                </div>
                :
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">New Oral Suspension Dosage Calculator</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Select type of the calculator to add.</p>
                        </div>
                        <div className="modal-footer">
                                <div className="col-lg-4 col-sm-12">
                                <a href="#" className="btn btn-accent m-btn m-btn--pill  m-btn--air" style={{float:'inline-end'}} onClick={()=>{this.setState({newFormulaView:true,calculationType:'Formula'})}}>
                                    <span><i className="la la-plus"></i><span>Use Formula</span></span>
                                </a>
                                </div>
                                <div className="col-lg-4 col-sm-12">
                                <a href="#" className="btn btn-accent m-btn m-btn--pill  m-btn--air "  onClick={()=>{this.setState({newDosageView:true,calculationType:'Dosage'})}}>
                                    <span><i className="la la-plus"></i><span>Use Pre-set Dosage</span></span>
                                </a>
                                </div>
            
                        </div>
                    </div>
                </div>
                }
            </div>
        )
    }
}
const mapStateToProps = state => ({
    user: state.cognito.user,
    petShop: state.petShopReducer,
    setCalculations: state.addFormulaReducer.setCalculations,
    setCalculationsError:state.addFormulaReducer.setCalculationsError,  
});
  
const mapDispatchToProps = dispatch => ({
    createFormula: (attrs) => {
        dispatch(createFormula(attrs))
        .catch(error => {
            NotificationManager.error("Something went wrong");
        });
    }
})
  
  
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewOralSuspension));